import type { ExploreContentResponsePageAllOfThreeContentItem } from './exploreContentResponsePageAllOfThreeContentItem';

export type ExploreContentResponsePageAllOfThree = {
  content?: ExploreContentResponsePageAllOfThreeContentItem[];
};
